import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Navbar } from '@/components/site/Navbar';
import { Footer } from '@/components/site/Footer';
import { setPageMeta } from '@/lib/seo';
import { useT, useLang } from '@/lib/i18n';
import { Home, ArrowLeft, Sparkles } from 'lucide-react';

export default function NotFound() {
  const t = useT();
  const { lang } = useLang();
  useEffect(() => {
    setPageMeta({
      title: t('not_found.seo_title'),
      description: t('not_found.seo_description'),
      path: '/404',
    });
    window.scrollTo({ top: 0, behavior: 'instant' });
  }, [t, lang]);

  return (
    <div data-testid="page-404">
      <Navbar />
      <main className="pt-[120px]">
        <section className="relative overflow-hidden py-20 md:py-28">
          <div aria-hidden className="pointer-events-none absolute inset-0 -z-10">
            <div
              className="om-anim-halo absolute left-1/2 top-1/3 h-[520px] w-[520px] -translate-x-1/2 rounded-full blur-3xl"
              style={{ background: 'radial-gradient(closest-side, rgba(139,92,246,0.24), rgba(16,185,129,0.14), transparent 70%)' }}
            />
          </div>

          <div className="om-container">
            <div className="mx-auto max-w-2xl text-center">
              <div className="inline-flex items-center gap-2 rounded-full border border-[var(--om-border)] bg-white/70 px-3 py-1 text-xs font-bold uppercase tracking-wider text-[var(--om-muted)] backdrop-blur">
                <Sparkles size={12} strokeWidth={2.6} /> {t('not_found.badge')}
              </div>

              <h1
                className="om-h1 mt-6 text-[64px] sm:text-[96px] lg:text-[128px] text-[var(--om-ink)]"
                data-testid="notfound-title"
                style={{
                  backgroundImage:
                    'linear-gradient(120deg, #10B981 0%, #8B5CF6 45%, #F43F5E 80%, #F97316 100%)',
                  WebkitBackgroundClip: 'text',
                  WebkitTextFillColor: 'transparent',
                  backgroundClip: 'text',
                }}
              >
                {t('not_found.title')}
              </h1>

              <h2 className="mt-2 text-[24px] sm:text-[32px] font-bold text-[var(--om-ink)]" data-testid="notfound-heading">
                {t('not_found.heading')}
              </h2>
              <p className="mx-auto mt-4 max-w-lg text-base leading-relaxed text-[var(--om-muted)]">
                {t('not_found.subtitle')}
              </p>

              <div className="mx-auto mt-10 flex flex-wrap items-center justify-center gap-3">
                <Link to="/" className="om-btn-primary" data-testid="notfound-cta-home">
                  <Home size={14} strokeWidth={2.4} />
                  {t('not_found.cta_home')}
                </Link>
                <Link to="/generateur" className="om-btn-ghost" data-testid="notfound-cta-generator">
                  <ArrowLeft size={14} strokeWidth={2.4} />
                  {t('not_found.cta_generator')}
                </Link>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
